<template>
  <div>
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="form">
      <a-form-model-item label="服务商id">
        <a-input :disabled="true" v-model="form.serviceProviderId" />
      </a-form-model-item>
      <a-form-model-item label="服务商名称" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <!-- <a-form-model-item label="备注">
        <a-textarea
          v-model="form.remark"
          placeholder="服务商备注"
          :auto-size="{ minRows: 15, maxRows: 20 }"
          size="large"
        />
      </a-form-model-item> -->
      <a-form-item class="group-btn">
        <a-button type="primary" @click="updateServiceProvider">确定</a-button>
        <a-button class="creator-btn" @click="cancel">返回</a-button>
      </a-form-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: 'ServiceProviderEdit',
  components: {},
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      rules: {
        name: [{ required: true, message: '服务商名称 不能为空', trigger: 'blur' }],
      },
      filterSelected: ['服务商名称'],
      filterOptions: ['服务商名称', '服务商地址'],
      form: {
        serviceProviderId: null,
        name: null,
        // remark: null,
        type: 0,
      },
    };
  },
  mounted() {
    this.form = this.$route.params.serviceProvider;
    if (!this.form) {
      this.$router.back();
    }
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    updateServiceProvider() {
      this.$refs.form.validate((relsValid) => {
        if (relsValid) {
          this.$apiManager.serviceProvider.updateServiceProviders(this.form).then(() => {
            this.$message.success('修改成功');
          });
        } else {
          this.$message.warn('基础信息存在未填写的数据');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.edit-btn {
  color: green;
}
.delete-btn {
  color: red;
}
.creator-btn {
  margin-left: 5%;
}
.service-provicer-operations {
  display: flex;
  .add-btn {
    margin: 10px 0px;
    margin-left: 3%;
  }
  .service-table {
    margin-top: 2%;
  }
}
.group-btn {
  margin-left: 16.7%;
}
</style>
